import { MessageService } from '@philips-emr/tws-core/lib/services';
import { registerValidator, Validation } from '@philips-emr/tws-core/lib/services/model-service';

const PASSWORD_EQUALS = 'password-equals';

enum Validator {
  LENGTH = 'password-length',
  CONTAINS_LOWERCASE = 'password-contains-lowercase',
  CONTAINS_UPPERCASE = 'password-contains-uppercase',
  CONTAINS_NUMBER = 'password-contains-number',
  CONTAINS_SIMBOL = 'password-contains-simbol',
}

const validators: { [key in Validator]: { message: string, validation: (value: string) => boolean } } = {
  [Validator.LENGTH]: {
    message: 'beneficiary.entre-caracteres',
    validation: (value: string): boolean => value.length >= 8 && value.length <= 16,
  },
  [Validator.CONTAINS_LOWERCASE]: {
    message: 'beneficiary.conter-minuscula',
    validation: (value: string): boolean => isValid(value, /[a-z]/g),
  },
  [Validator.CONTAINS_UPPERCASE]: {
    message: 'beneficiary.conter-maiuscula',
    validation: (value: string): boolean => isValid(value, /[A-Z]/g),
  },
  [Validator.CONTAINS_NUMBER]: {
    message: 'beneficiary.conter-numero',
    validation: (value: string): boolean => isValid(value, /[\d]/g),
  },
  [Validator.CONTAINS_SIMBOL]: {
    message: 'beneficiary.conter-simbolo',
    validation: (value: string): boolean => isValid(value, /[\W_]/g),
  },
};

function passwordValidator(): void {
  Object.entries(validators).forEach(([key, props]) =>
    registerValidator(key, (value: string): Validation[] =>
      [{
        message: MessageService.translate(props.message),
        name: key,
        valid: !!value && props.validation(value),
      }]
    )
  );
}

function isValid(value: string, matcher: RegExp): boolean {
  const result = value.match(matcher);

  if (Array.isArray(result)) {
    return result.length >= 1;
  }
  return false;
}

function passwordEqualsValidator(value: string, equals: string): Validation[] {
  const valid = equals !== value;

  return [{
    message: !valid ? 'beneficiary.senha-nao-igual' : '',
    name: PASSWORD_EQUALS,
    valid,
  }];
}

export {
  PASSWORD_EQUALS,
  passwordEqualsValidator,
  passwordValidator,
};
